<div *ngIf="vars?.showCouponOffer" class="offer-wrapper">
  <div class="offer-card">
    <div class="cross" (click)="closeDialog()">
      <mat-icon> close</mat-icon>
    </div>

    <div class="offer-logo">
      <img src="/assets/images/up-side.png" alt="up-side">
      <div class="amt-text"><app-currency-icon [currency]="config?.currency"></app-currency-icon>{{config?.offerAmount}}</div>
    </div>

    <div class="heading">Offer Unlocked!</div>

    <div class="desc">Join Monthly Giving and we'll add <strong> <app-currency-icon [currency]="config?.currency"></app-currency-icon>{{config?.offerAmount}} </strong> to your first monthly contribution!</div>

    <div class="seperator"></div>

    <div class="proceed-div">
      <div class="proceed" (click)="applyCoupon()">PROCEED</div>
    </div>
  </div>
</div>
